import { Injectable } from '@angular/core';
import {
  Directory,
  Filesystem,
} from '@capacitor/filesystem';
import { Capacitor } from '@capacitor/core';
import data from '../../assets/data/en-US/video_config.json';
import { environment } from 'environments/environment';
import { Platform } from '@ionic/angular';
import { Logger } from '@pfizer/newton-jetpack-utils';

@Injectable({
  providedIn: 'root',
})
export class VideoDownloadService {
  private readonly videoURL: string;
  private readonly baseURL = environment.baseURL;
  private readonly videos = data.videoData;
  public filePath;

  constructor( private readonly platform: Platform, private readonly logger: Logger){}

  public async downloadAllVideos() {
    await this.setFilePath();
    for (const video of this.videos) {
      try {
        await this.downloadVideo(video.url, video.filename);
      } catch (error) {
        this.logger.log(error);
      }
    }
  }

  private async setFilePath(){
    const filePathResult = await Filesystem.getUri({
      path: '',
      directory: this.platform.is('android') ? Directory.Data : Directory.Documents,
    });
    this.filePath = Capacitor.convertFileSrc(filePathResult.uri);
  }

  public async downloadVideo(fileURL: string, filename: string) {
    const fullUrl = fileURL.startsWith('http')
      ? fileURL
      : `${this.baseURL}${fileURL}`;

    await Filesystem.downloadFile({
      url: fullUrl,
      path: `${filename}`,
      directory: this.platform.is('android') ? Directory.Data : Directory.Documents,
      headers: {
        'access-control-allow-origin': '*',
      },
    });
  }

  public getVideoObjectByFilename(filename) {
    for (const video of this.videos) {
      if (video.filename === filename) {
        return video;
      }
    }

    return null;
  }

  public async isFileExist(filename: string) {
    try{
      await Filesystem.stat({
        path: filename,
        directory: this.platform.is('android') ? Directory.Data : Directory.Documents,
      });

      return false;
    } catch(e){
      this.logger.log(e);

      return true;
    }


  }
}
